import { LawTopicEnum } from '@/types/generated'

export const lawTopicsFR: Record<string, string> = {
  [LawTopicEnum.KÜNDIGUNG]: 'Rupture du contrat de travail',
  [LawTopicEnum.ABFINDUNG]: 'Indemnité de rupture',
  [LawTopicEnum.AUFHEBUNGSVERTRAG]: 'Rupture conventionnelle',
  [LawTopicEnum.ARBEITSZEUGNIS]: 'Certificat de travail',
  [LawTopicEnum.ABMAHNUNG]: 'Sanction disciplinaire / avertissement',
  [LawTopicEnum.URLAUB]: 'Congés payés',
  [LawTopicEnum.ARBEITSVERTRAG]: 'Contrat de travail',
  [LawTopicEnum.ARBEITSUNFALL]: 'Accident du travail',
  [LawTopicEnum.ÜBERSTUNDEN]: 'Heures supplémentaires',
  [LawTopicEnum.LOHNZAHLUNG]: 'Paiement du salaire',
  [LawTopicEnum.MOBBING]: 'Harcèlement moral',
  [LawTopicEnum.DISKRIMINIERUNG]: 'Discrimination',
  [LawTopicEnum.EINGRUPPIERUNG]: 'Classification / coefficient / convention collective',
  [LawTopicEnum.ARBEITSAMT_ALG_SPERRZEIT]:
    "France Travail / allocations chômage / délai ou sanction d'indemnisation",
  [LawTopicEnum.ANDERES]: 'Autre'
}
